import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ProblemList } from '../../models/profile';
import { QuestionErrorService } from '../../services/question-error.service';

@Component({
  selector: 'app-ask-expert-list',
  templateUrl: './ask-expert-list.component.html',
  styleUrls: ['./ask-expert-list.component.scss'],
})

export class AskExpertListComponent implements OnInit {
  problemList: Array<ProblemList> = [];
  databaseError: boolean = false;
  loading: boolean = true;
  constructor(private questionErrorService: QuestionErrorService, private loadingService: LoadingService, private router: Router) { }

  ngOnInit() { }

  ionViewDidEnter() {
    this.getProblemList();
  }

  getProblemList() {
    this.loading = true;
    this.problemList = [];
    this.loadingService.showLoading();
    this.questionErrorService.getQuestions().subscribe(e => {
      if (e.IsSuccess) {
        this.problemList = e.Data;
      } else {
        this.databaseError = true;
      }
      this.loading = false;
      this.loadingService.hideLoading();
    }, err => {
      this.databaseError = true;
      this.loading = false;
      this.loadingService.hideLoading();
    });
  }

  detailQuestion(item?: ProblemList) {
    let url = this.router.url + "-detail";
    this.router.navigate([url], {
      queryParams: {
        id: item?.MasterId
      }
    });
  }

}
